import { Send } from 'lucide-react';
import { FormData } from '../../types';
import { useState } from 'react';

interface AdditionalNotesProps {
  formData: FormData;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleExport: () => void;
  generatedPrompt: () => any;
}

export const AdditionalNotes = ({
  formData,
  handleInputChange,
  generatedPrompt
}: AdditionalNotesProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    setSubmitError(null);
    setSubmitSuccess(false);

    const briefData = generatedPrompt();
    console.log('Submitting brief data:', briefData);

    try {
      const response = await fetch('https://hook.us1.make.com/pz485qfakchdisbndkqj5y66rnqpozne', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(briefData),
      });

      if (!response.ok) {
        throw new Error('Failed to submit design brief');
      }

      setSubmitSuccess(true);
    } catch (error) {
      setSubmitError('Failed to submit design brief. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-8">
      <h2 className="text-xl sm:text-2xl font-semibold flex items-center gap-3 text-blue-900">
        <Send className="text-[#6366F1]" />
        Additional Notes
      </h2>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Any additional requirements or notes?
        </label>
        <textarea
          name="additionalNotes"
          value={formData.additionalNotes}
          onChange={handleInputChange}
          rows={4}
          className="input-field"
          placeholder="Add any specific requirements or preferences..."
        />
      </div>

      {submitError && (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-600">{submitError}</p>
        </div>
      )}

      {submitSuccess && (
        <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-sm text-green-600">
            Design brief submitted successfully! We'll be in touch soon.
          </p>
        </div>
      )}

      <div className="flex justify-start">
        <button
          onClick={handleSubmit}
          disabled={isSubmitting}
          className="btn-primary px-4 py-2 text-sm"
        >
          <div className="flex items-center justify-center gap-2">
            <Send size={16} />
            {isSubmitting ? 'Submitting...' : 'Submit my design brief'}
          </div>
        </button>
      </div>
    </div>
  );
};